import React from 'react';
const SpaceEditContext = React.createContext({});
export const SpaceEditProvider = SpaceEditContext.Provider;
export default SpaceEditContext;